import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'messageDate',
    standalone: true,
})
export class MessageDatePipe implements PipeTransform {
    private readonly datePipe = new DatePipe(this._locale);

    constructor(
        @Inject(LOCALE_ID) private readonly _locale: string,
        private _translateService: TranslateService
    ) {}

    transform(
        value: string | Date | null | undefined,
        format = 'MM/dd/yy HH:mm',
        timezone?: string,
        locale?: string
    ): string {
        const currentLang = this._translateService.currentLang;

        const date =
            typeof value === 'string' ? new Date(value.endsWith('Z') ? value : value + 'Z') : (value ?? new Date());
        const today = new Date();

        const diffInTime = today.getTime() - date.getTime();
        const diffInDays = diffInTime / (1000 * 3600 * 24);

        if (diffInDays < 7) {
            format = format ?? 'EEEE HH:mm';
        }

        return this.datePipe.transform(date, format, timezone, currentLang) ?? '';
    }
}
